import React from 'react';
import { TradeAlert } from 'store/services/tradeAlerts/tradeAlertsApi';
import { UserIdentityBlock } from 'components/UserIdentityBlock';
import { AlertCardTile } from './AlertCardTile';

interface AlertCardProps {
  alert: TradeAlert;
  /** Which tab the card is being shown in — controls the dismiss vs restore icon. */
  variant: 'all' | 'hidden';
  onSend: (alert: TradeAlert) => void;
  onHide: (alert: TradeAlert) => void;
  onUnhide: (alert: TradeAlert) => void;
}

/**
 * "By card" view: a standalone alert card — the card tile with the requester identity
 * block rendered below it. In "By trader" view the page renders AlertTradeGroup instead,
 * which reuses AlertCardTile + UserIdentityBlock with the profile deduped to a header.
 */
export const AlertCard: React.FC<AlertCardProps> = ({ alert, variant, onSend, onHide, onUnhide }) => (
  <AlertCardTile
    alert={alert}
    variant={variant}
    onSend={onSend}
    onHide={onHide}
    onUnhide={onUnhide}
    profile={
      <UserIdentityBlock
        username={alert.requester.username}
        avatarUrl={alert.requester.avatarUrl}
        country={alert.requester.country}
        points={alert.requester.points}
        isElite={alert.requester.isElite}
        showAnimatedBorder={alert.requester.showAnimatedBorder}
        borderColor1={alert.requester.borderColor1}
        borderColor2={alert.requester.borderColor2}
      />
    }
  />
);

export default AlertCard;
